import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { HEADER_HEIGHT } from 'global/config';

export const GoogleOneTapContainer = styled.div`
  position: fixed;
  top: ${HEADER_HEIGHT + 5}px;
  right: 5px;
  z-index: ${themeStyle.zIndexL9};
`;
